import get from 'lodash/get';
import { mapActions, mapState } from 'vuex';

export const pagination = {
	computed: {
		...mapState('monsterleads', ['page']),
	},
	mounted() {
		this.setPageVars({
			page: this.$get('$route.params.leadsPage', this.page),
		});

		if (!this.isLoading) {
			this.fetch();
		}

		this.$bus.$on('fetchedMe', this.fetch);
	},
	beforeDestroy() {
		this.$bus.$off('fetchedMe', this.fetch);
	},
	destroyed() {
		this.resetPageVar();
	},
	/**
	 * Called when the route that renders this component is about to be
	 * navigated away from.
	 *
	 * @since  2.0.0
	 *
	 * @param {object} to New route.
	 * @param {object} from Old route.
	 * @param {Function} next Tells Vue Router we can proceed.
	 *
	 * @returns {void}
	 */
	beforeRouteLeave(to, from, next) {
		if ('monsterleads' !== get(to, 'meta.parent') && 'monsterleads' !== get(to, 'name')) {
			// If going away from page, need to reset the page vars.
			this.resetPageVar();
		}
		next();
	},
	watch: {
		$route(to) {
			this.setPageVars({ page: get(to, 'params.leadsPage', 1) });
			this.fetch();
		},
	},
	methods: {
		...mapActions('monsterleads', ['setPageVars', 'resetPageVar']),
	},
};
